import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbAccordionModule, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseAdministrationEffects, baseAdministrationReducer } from '../../_store';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { BaseAdministrationShiftFormComponent } from './_components/base-administration-shift-form/base-administration-shift-form.component';
import { BaseAdministrationComponent } from './_components/base-administration/base-administration.component';
import { BaseMasterAddressFormComponent } from './_components/base-master-data/base-master-address-form/base-master-address-form.component';
import { BaseGeneralInfoFormComponent } from './_components/base-master-data/base-general-info-form/base-general-info-form.component';
import { BaseMasterDataDocumentComponent } from './_components/base-master-data/base-master-data-document/base-master-data-document.component';
import { BaseOrganisationManagementListHeadlineComponent } from './_components/base-organisation-management/base-organisation-management-list-headline/base-organisation-management-list-headline.component';
import { BaseOrganisationManagementListItemComponent } from './_components/base-organisation-management/base-organisation-management-list-item/base-organisation-management-list-item.component';
import { BaseOrganisationManagementComponent } from './_components/base-organisation-management/base-organisation-management/base-organisation-management.component';
import { BaseProfileManagementComponent } from './_components/base-profile-management/base-profile-management.component';
import { BaseTermsOfContractSurchargeComponent } from './_components/base-terms-of-contract/base-terms-of-contract-surcharge/base-terms-of-contract-surcharge.component';
import { BaseTermsOfContractComponent } from './_components/base-terms-of-contract/base-terms-of-contract.component';
import { BaseChangeUserPasswordFormComponent } from './_components/base-user-management/base-change-user-password-form/base-change-user-password-form.component';
import { BaseEditPermissionGroupsFormComponent } from './_components/base-user-management/base-edit-permission-groups-form/base-edit-permission-groups-form.component';
import { BaseEditUserFormComponent } from './_components/base-user-management/base-edit-user-form/base-edit-user-form.component';
import { BaseInviteUserFormComponent } from './_components/base-user-management/base-invite-user-form/base-invite-user-form.component';
import { BasePermissionGroupsComponent } from './_components/base-user-management/base-permission-groups/base-permission-groups.component';
import { BaseUserListItemComponent } from './_components/base-user-management/base-user-list-item/base-user-list-item.component';
import { BaseUserManagementComponent } from './_components/base-user-management/base-user-management/base-user-management.component';
import { BaseOrganizationManagementGuard } from './_guards/base-organization-management.guard';
import { BasePermissionsGuard } from './_guards/base-permissions.guard';
import { BaseAdministrationFormComponent } from './_models/base-administration-form';
import { BaseAdministrationService } from './base-administration.service';
import { BaseAssignmentsModule } from '../assignments/base-assignments.module';
import { BasePermissionCheckboxTemplateComponent } from './_components/base-user-management/base-permission-checkbox-template/base-permission-checkbox-template.component';
import { BaseAddressFormComponent } from './_components/base-master-data/base-address-form/base-address-form.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BaseSharedModule,
    BaseAssignmentsModule,
    AppsSharedModule,
    NgbAccordionModule,
    NgbTooltipModule,
    NgbModalModule,
    StoreModule.forFeature('administration', baseAdministrationReducer.baseAdministrationReducer),
    EffectsModule.forFeature([baseAdministrationEffects.BaseAdministrationEffects]),
  ],
  declarations: [
    BaseAdministrationFormComponent,
    BaseAdministrationComponent,
    BaseUserManagementComponent,
    BasePermissionGroupsComponent,
    BaseUserListItemComponent,
    BaseInviteUserFormComponent,
    BaseEditUserFormComponent,
    BaseEditPermissionGroupsFormComponent,
    BaseTermsOfContractComponent,
    BaseTermsOfContractSurchargeComponent,
    BaseProfileManagementComponent,
    BaseGeneralInfoFormComponent,
    BaseMasterAddressFormComponent,
    BaseAddressFormComponent,
    BaseMasterDataDocumentComponent,
    BaseAdministrationShiftFormComponent,
    BaseOrganisationManagementComponent,
    BaseOrganisationManagementListItemComponent,
    BaseOrganisationManagementListHeadlineComponent,
    BaseChangeUserPasswordFormComponent,
    BasePermissionCheckboxTemplateComponent,
  ],
  exports: [
    BaseAdministrationFormComponent,
    BaseAdministrationComponent,
    BaseUserManagementComponent,
    BasePermissionGroupsComponent,
    BaseUserListItemComponent,
    BaseInviteUserFormComponent,
    BaseEditUserFormComponent,
    BaseEditPermissionGroupsFormComponent,
    BaseProfileManagementComponent,
    BaseTermsOfContractComponent,
    BaseTermsOfContractSurchargeComponent,
    BaseAdministrationShiftFormComponent,
    BaseGeneralInfoFormComponent,
    BaseMasterAddressFormComponent,
    BaseAddressFormComponent,
    BaseMasterDataDocumentComponent,
    BaseOrganisationManagementComponent,
    BaseOrganisationManagementListItemComponent,
    BaseOrganisationManagementListHeadlineComponent,
    BaseChangeUserPasswordFormComponent,
    BasePermissionCheckboxTemplateComponent,
  ],
  providers: [BaseAdministrationService, BasePermissionsGuard, BaseOrganizationManagementGuard],
})
export class BaseAdministrationModule {}
